import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'


import { cn } from '@shared/lib/cn'
import Accordion from '@shared/ui/accordion'
import Input from '@shared/ui/input'
import { formatNumber } from '@shared/uttils'

import styles from './styles.module.scss'


interface RangeDecimalProps {
  defaultOpen?: boolean;
  name: string | undefined | null;
  min?: number;
  max?: number;
  value: [number | undefined, number | undefined];
  disabled?: boolean;
  showCurrency?: boolean;
  onChange: (value: [number | undefined, number | undefined]) => void;
}

export default function RangeDecimal (props: RangeDecimalProps) {
  const { t: tc } = useTranslation('common')
  const {
    name = '',
    defaultOpen,
    min,
    max,
    value,
    showCurrency,
    onChange,
  } = props
  const [ inputMin, setInputMin ] = useState(value[0]?.toString() || '')
  const [ inputMax, setInputMax ] = useState(value[1]?.toString() || '')
  const [ isEditingMin, setIsEditingMin ] = useState(false)
  const [ isEditingMax, setIsEditingMax ] = useState(false)

  const handleMinBlur = () => {
    const trimmed = inputMin.trim()

    if (trimmed === '') {
      onChange([ undefined, value[1] ])

      return
    }

    let parsed = parseInt(trimmed, 10)
    if (isNaN(parsed)) parsed = min ?? 0
    if (min !== undefined && parsed < min) parsed = min
    if (value[1] !== undefined && parsed > value[1]) parsed = value[1]
    onChange([ parsed, value[1] ])
  }

  const handleMaxBlur = () => {
    const trimmed = inputMax.trim()

    if (trimmed === '') {
      onChange([ value[0], undefined ])
      return
    }

    let parsed = parseInt(trimmed, 10)
    if (isNaN(parsed)) parsed = max ?? 0
    if (max !== undefined && parsed > max) parsed = max
    if (value[0] !== undefined && parsed < value[0]) parsed = value[0]
    onChange([ value[0], parsed ])
  }

  useEffect(() => {
    if (!isEditingMin && !isEditingMax) {
      setInputMin(value[0]?.toString() || '')
      setInputMax(value[1]?.toString() || '')
    }
  }, [ value, isEditingMin, isEditingMax ])

  return (
    <Accordion
      triggerClassName={styles['trigger-wrapper']}
      trigger={
        <button type="button" className={cn('reset-button', styles.trigger)}>
          {name}
        </button>
      }
      content={
        <div className={styles.content}>
          <Input
            type="text"
            placeholder={
              min !== undefined ? `От ${formatNumber(min, showCurrency)}` : 'От'
            }
            inputSize="large"
            onlyNumbers
            value={inputMin}
            onChange={(e) => {
              setInputMin(e.target.value)
              setIsEditingMin(true)
            }}
            onBlur={() => {
              handleMinBlur()
              setIsEditingMin(false)
            }}
          />
          <Input
            type="text"
            placeholder={
              max !== undefined
                ? `${tc('up_to')} ${formatNumber(max, showCurrency)}`
                : tc('up_to')
            }
            inputSize="large"
            onlyNumbers
            value={inputMax}
            onChange={(e) => {
              setInputMax(e.target.value)
              setIsEditingMax(true)
            }}
            onBlur={() => {
              handleMaxBlur()
              setIsEditingMax(false)
            }}
          />
        </div>
      }
      defaultOpen={defaultOpen}
    />
  )
}
